import React from "react";
import "../Footer.css";

const ContactInfo: React.FC = () => {
  return (
    <div className="footer-contact-info">
      <p>Forluz - Fundação Forluminas de Seguridade Social</p>
      <p>R. Conde de Linhares, 77 - Cidade Jardim, Belo Horizonte</p>
      <p>MG, CEP 30380-030</p>
    </div>
  );
};

export default ContactInfo;
